export default __webpack_public_path__ + "static/Hyundai Tucson-af09e57b2834c3563c3d16c57c1eae6d.jpg";